const { h, Component } = require('preact');

let CHAR_LIMIT = 0;
function wordsLeft(text) {
    return CHAR_LIMIT - text.length;
}

class CommentBox extends Component {
    constructor(props) {
        super(props);
        CHAR_LIMIT = Groupon.Utils.getConfigFromDom().feedbackTextMaxLen;
        this.state = {
            charsLeft: CHAR_LIMIT
        }
        this.handleInput = this.handleInput.bind(this);
    }

    handleInput(e) {
        const val = e.target.value;
        this.setState({ charsLeft: wordsLeft(val) });
        this.props.onInput(val);
    }
    render() {
        const charsLeft = `${this.state.charsLeft} ${I18n.translate('js.modules.web_2018.feedback.characters_left')}`
        return (
            <div class="feedback-comments">
                <h5 class="title">{this.props.title}</h5>
                <i class="optional">{I18n.translate('js.modules.web_2018.feedback.optional')}</i>
                <textarea onInput={this.handleInput} maxlength={CHAR_LIMIT} class="feedback-comment-box" id="feedback-comment-box" data-bhw="CUSTOMER-FEEDBACK::feedback_form_comment_box"></textarea>
                <i class="chars-left">{charsLeft}</i>
                <span class="disclaimer">{'*' + I18n.translate('js.modules.web_2018.feedback.disclaimer')}</span>
            </div>
        );
    }
}
module.exports = CommentBox;